import React from 'react';
export function About() {
  return <section id="about" className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black" data-id="element-21">
      <div className="max-w-7xl mx-auto" data-id="element-22">
        <div className="max-w-4xl" data-id="element-23">
          <div data-id="element-24">
            <h2 className="text-4xl font-bold text-white mb-6" data-id="element-25">
              Your Business Deserves Funding
            </h2>
            <p className="text-lg text-zinc-300 mb-6" data-id="element-26">
              You're running a real business. Doing real revenue. Managing real
              cash flow. And you need capital to:
            </p>
            <div className="text-lg text-zinc-200 mb-6 space-y-4" data-id="element-27">
              <p data-id="element-28"> -Grab inventory before your competitor does</p>
              <p data-id="element-29">-Hire the team member who'll 10x your output</p>
              <p data-id="element-30">-Cover payroll while waiting on a big receivable</p>
              <p data-id="element-31">-Upgrade equipment that's holding you back</p>
              <p data-id="element-32">-Say YES to the contract sitting on your desk</p>
            </div>
            <p className="text-lg text-zinc-300 mb-4" data-id="element-33">
              Banks make you wait 6-8 weeks while the opportunity vanishes.
            </p>
            <p className="text-lg text-white font-bold mb-4" data-id="element-34">
              We get you funded in 72 hours.
            </p>
            <p className="text-lg text-white font-bold mb-6" data-id="element-35">
              $127M deployed to operators who couldn't wait.
            </p>
            <p className="text-lg text-zinc-300 mb-6" data-id="element-36">
              We look at your business performance, not your credit history. We
              fund based on your cash flow today, not what happened 3 years ago.
            </p>
            <p className="text-lg text-zinc-300 mb-6" data-id="element-37">
              If you're running a solid operation and need capital this week to
              seize an opportunity or solve a problem we're built for this exact
              moment.
            </p>
            <p className="text-lg text-zinc-300 italic" data-id="element-38">
              The question isn't whether we can help. It's whether you can
              afford to wait.
            </p>
          </div>
        </div>
      </div>
    </section>;
}